import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { AtsArchiveJobPostingDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'
import app from 'modules/core/store/models/app'

interface Props {
  careersUrl: string
  id: string
  onClose: () => void
}

export const ArchiveJobPostingModal = ({ careersUrl, id, onClose }: Props) => {
  const [archiveJobPosting] = useMutation(AtsArchiveJobPostingDocument, {
    extractorFn: (data) => data.atsMutations.updateAtsJobPosting,
  })

  const onSubmit = async () => {
    const result = await archiveJobPosting({
      variables: {
        id,
      },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })

      dispatch({
        type: EventTypes.JOB_POSTING_STATUS_CHANGED,
      })

      onClose()
    }

    return handled
  }

  return (
    <Modal
      illustration="archive"
      title={i18n.t('ats.job_details.archive_confirmation.title')}
      description={i18n.tView('ats.job_details.archive_confirmation.description', {
        careers_page_link: (
          <a rel="nofollow noopener noreferrer" target="_blank" href={careersUrl}>
            {i18n.t('ats.job_details.archive_confirmation.careers_page_link')}
          </a>
        ),
      })}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={<Button submit>{i18n.t('ats.job_details.archive_confirmation.title')}</Button>}
    />
  )
}
